/**
 *
 * SegmentControl
 *
 */

import React from "react";
import PropTypes from "prop-types";
import scrollToComponent from "react-scroll-to-component";
import { trackContentInteraction } from "root/libs/core-libs/src";
import {
  UTF_EVENT_CONTENT_NAMES,
  UTF_EVENT_TYPES,
  UTF_EVENT_INTERACTIONS,
  UTF_EVENT_CONTENT_POSITION,
} from "root/libs/constants/src";
import SkeletonOr from "one-time-shipment/src/containers/SkeletonOr";
import { isScrollEnabled } from "one-time-shipment/src/helpers/isScrollDisabled";
import { SegmentControlWrapper, SegmentedListButton } from "./styled";

function scrollToSegment(segmentReference) {
  if (isScrollEnabled()) {
    scrollToComponent(segmentReference.current, {
      offset: -100,
      align: "top",
    });
  }
}

function handleUTF(newSegmentSelection, selectedSegment) {
  const { id } = newSegmentSelection;
  if (id !== selectedSegment) {
    // only when new segment is selected
    trackContentInteraction({
      name: UTF_EVENT_CONTENT_NAMES.CHANGE_SEGMENT,
      type: UTF_EVENT_TYPES.BUTTON,
      interaction: UTF_EVENT_INTERACTIONS.CLICK,
      position: UTF_EVENT_CONTENT_POSITION.TRADE_LANE,
      context: id,
    });
  }
}

function handleTabState(segment, selectedSegment, segmentReference) {
  handleUTF(segment, selectedSegment);
  if (isScrollEnabled()) {
    scrollToSegment(segmentReference);
  }
}

const SegmentControl = ({
  segments,
  className,
  onClickHandler,
  selectedSegment,
  segmentReference,
  dataTrackingKeyPath,
}) => {
  return (
    <SegmentControlWrapper
      className={className}
      role="tablist"
      aria-label={`${segments[0]?.headlineString} & ${segments[1]?.headlineString}`}
    >
      {segments.map((segment, index) => [
        <SegmentedListButton
          key={`${segment.id}list`}
          numberOfTabs={segments.length}
          role="tab"
          href={`#${segment.id}-tab`}
          id={segment.id}
          aria-controls="tradelane-panel"
          aria-selected={selectedSegment === segment.id}
          data-testid={`spot-shipment-${segment.id}-tab`}
          ref={index === 0 ? segmentReference : null}
          data-tracking={dataTrackingKeyPath}
          onClick={() => {
            handleTabState(segment, selectedSegment, segmentReference);
            onClickHandler(segment);
          }}
        >
          <span key={`${segment.id}link`} role="presentation">
            <SkeletonOr width={150}>{segment.headlineString}</SkeletonOr>
          </span>
        </SegmentedListButton>,
      ])}
    </SegmentControlWrapper>
  );
};

SegmentControl.prototype.propTypes = {
  className: PropTypes.string,
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      headlineString: PropTypes.string,
    })
  ).isRequired,
  onClickHandler: PropTypes.func,
  selectedSegment: PropTypes.string.isRequired,
  segmentReference: PropTypes.object,
  /** String indicating the path to track in the tracking contract */
  dataTrackingKeyPath: PropTypes.string,
};

SegmentControl.prototype.defaultProps = {
  className: "",
  segmentReference: React.createRef(),
  onClickHandler: () => {},
  dataTrackingKeyPath: "",
};

export default SegmentControl;
